/**
 * HORROR_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Horror / Tension scoring.
 * Features:
 * - High Dissonance (Clusters, Tritones, Minor 2nds)
 * - Hollow Voice Distribution (Extreme Lows and Highs, Empty Mid)
 * - Unpredictable Rhythm or Drones
 * - Terraced Dynamics (Jump Scares)
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const HORROR_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Often extremely slow (Drone) or erratic.
    // We target a slow churn to build dread.
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 8.0, // Very slow changes
        tolerance: 4.0,
        weight: 0.1
    },

    // Harmonic Consonance: The Inverted Goal.
    // We want high dissonance.
    harmonicConsonance: {
        ...SLOW_ARCHETYPE.harmonicConsonance,
        polarity: 'dissonant', // REWARD clashes
        weight: 0.4 // High importance
    },

    // Voice Distribution: "Hollow" EQ.
    // Avoid the comforting mid-range. Focus on deep bass and piercing highs.
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.40,  // Deep Drones/Impacts
        mid: 0.20,  // Relaxed from 0.10 to allow some texture
        high: 0.40, // Screeches/Violins
        tolerance: 0.30, // Relaxed from 0.15 to prevent failure on minor variance
        tuttiThreshold: 0.95
    },

    // Dynamic Curve: Jump Scares.
    // Similar to Baroque Terraced, but more extreme (Silence vs ffff).
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.20,
        targetVariance: 0.30,
        dynamicShape: 'stepwise' // Sudden changes
    },

    // Interval Entropy: Unpredictable.
    // Either static (0) or jagged leaps.
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.40, // Low stepwise motion (Jagged)
        tolerance: 0.30,
        weight: 0.1
    }
};
